// Drop form state shape (shared by the form + pricing summary).

export interface PushPullRow {
  filmType: string;
  stops: string; // "-2" | "-1" | "1" | "2"
}

export interface DropFormState {
  customer_name: string;
  customer_email: string;
  color35_count: string;
  color120_count: string;
  bw35_count: string;
  bw120_count: string;
  color35_notes: string;
  color120_notes: string;
  bw35_notes: string;
  bw120_notes: string;
  pushPull: PushPullRow[];
  scan_size: string; // small | high_res | max_res | none
  file_format: string; // jpg | tiff
  contact_sheets: boolean;
  scan_delivery: string; // email | gallery
  prints: string; // none | all | some
  negative_handling: string; // dispose | pickup | return
  pickup_format: string; // cut | uncut
  street1: string;
  street2: string;
  city: string;
  state: string;
  zip: string;
  prepaid_label: string; // yes | no  (mail-in only)
  use_preferences: string; // yes | no | ""
  join_club: string; // waitlist | no | already
  additional_notes: string;
  save_preferences: boolean;
  agree: boolean;
  newsletter: boolean;
}

export function blankDropForm(email: string): DropFormState {
  return {
    customer_name: "",
    customer_email: email,
    color35_count: "",
    color120_count: "",
    bw35_count: "",
    bw120_count: "",
    color35_notes: "",
    color120_notes: "",
    bw35_notes: "",
    bw120_notes: "",
    pushPull: [],
    scan_size: "",
    file_format: "", // no default — the real form requires an explicit choice
    contact_sheets: false,
    scan_delivery: "",
    prints: "",
    negative_handling: "",
    pickup_format: "cut",
    street1: "",
    street2: "",
    city: "",
    state: "",
    zip: "",
    prepaid_label: "",
    use_preferences: "",
    join_club: "",
    additional_notes: "",
    save_preferences: false,
    agree: false,
    newsletter: false,
  };
}
